const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class CtaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 5000,
        },
        loop: true,
        mode: 'snap',
        slides: {
          origin: 'center',
          perView: 1.3,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              origin: 'center',
              perView: 1.4,
              spacing: 0,
            },
          },
        },
        detailsChanged: (instance) => {
          this.els.media.elements.forEach((mediaEl, index) => {
            const matchingSlide = instance.track.details.slides[index]

            const slidePortion = matchingSlide.portion

            instance.slides[index].setAttribute(
              'aria-hidden',
              slidePortion < 0.8,
            )

            const cropLimit = window.BAO.MediaBreakpoints.isMd ? 100 : 60
            const cropAmount = cropLimit - cropLimit * slidePortion

            mediaEl.style.height = `calc(100% - ${cropAmount}px)`
          })
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('cta-carousel')) {
  customElements.define('cta-carousel', CtaCarousel)
}
